import styled from 'styled-components';
import { device } from '../../theme/MediaQueries';
import ThemeDefault from '../../theme/ThemeDefault';
import GoBack from '../GoBack';

const HeroSection = styled.section`
	+ section .section-inner {
		padding-top: 0;
	}

	padding-top: clamp(7.2rem, calc(5vw + 5.6rem), 12rem);
	padding-bottom: clamp(7.2rem, calc(5vw + 5.6rem), 12rem);
	padding-left: 0;
	padding-right: 0;
	overflow: visible;
	background-repeat: no-repeat;
	background-size: cover;
	height: 60vh;
	min-height: 600px;
	max-height: 700px;
	justify-content: center;

	@media ${device.MXmd} {
		padding-top: 2.4rem;
		/* padding-bottom: 3.2rem; */
		height: auto;
		min-height: 0;
	}

	.titleWrap {
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-content: center;
		align-items: flex-start;
		justify-content: center;
		padding: 2.4rem;
	}
`;

const Title = styled.h1`
	line-height: 1.2;
	margin: 0;
	margin-bottom: 0.8rem;
	font-size: calc(1.4 * var(--text-xxl));
	width: auto;

	@media ${device.md} {
		padding: 0.8rem 1.6rem;
		margin-bottom: 0;
		background: ${ThemeDefault.trueBlack};
		border-radius: 0.8rem;
		box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
			0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
			0px 22.3px 17.9px rgba(0, 0, 0, 0.042), 0px 41.8px 33.4px rgba(0, 0, 0, 0.05),
			0px 100px 80px rgba(0, 0, 0, 0.07);
	}
`;

const SubTitle = styled.div`
	font-size: var(--text-l);
	margin-top: 1.6rem;
`;

const HeroText = styled.div`
	font-size: var(--text-m);
	margin-top: 3.2rem;
`;

const PreTitle = styled.div`
	font-size: var(--text-l);
	margin-bottom: 0.8rem;
	color: ${ThemeDefault.white};
`;

const HeroImageWrap = styled.div`
	position: relative;

	@media ${device.MXmd} {
		min-height: 400px;
	}
	@media ${device.MXsm} {
		min-height: 300px;
	}

	& .hero-bg-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	& .spacer {
		height: 100%;
		margin: 2.4rem;
		position: relative;

		@media ${device.MXsm} {
			margin: 0 2.4rem 2.4rem 2.4rem;
		}
	}
`;

const LogoWrapHero = styled.div`
	width: 70%;
	max-width: 320px;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);

	& img {
		width: 100%;
	}
`;
const HeroVideo = styled.video`
	position: absolute;
	width: calc(130%);
	height: calc(120% + 2.4rem);
	object-fit: cover;
	right: 0%;
	top: 50%;
	transform: translate(0, -50%);
	overflow: hidden;
	z-index: 0;
	border-radius: 2.4rem;
	box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
		0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
		0px 22.3px 17.9px rgba(0, 0, 0, 0.042), 0px 41.8px 33.4px rgba(0, 0, 0, 0.05),
		0px 100px 80px rgba(0, 0, 0, 0.07);

	@media ${device.MXmd} {
		width: 100%;
		height: 100%;
		right: 50%;
		top: 50%;
		transform: translate(50%, -50%);
	}
`;

const HeroImage = styled.div.attrs((props) => ({
	className: props.cssClass,
}))`
	background-image: url(${(props) => props.heroImage});
	position: absolute;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	width: calc(130%);
	height: calc(120% + 2.4rem);
	overflow: hidden;
	right: 0%;
	top: 50%;
	transform: translate(0, -50%);
	z-index: 0;
	border-radius: 2.4rem;
	box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
		0px 6.7px 5.3px rgba(0, 0, 0, 0.028), 0px 12.5px 10px rgba(0, 0, 0, 0.035),
		0px 22.3px 17.9px rgba(0, 0, 0, 0.042), 0px 41.8px 33.4px rgba(0, 0, 0, 0.05),
		0px 100px 80px rgba(0, 0, 0, 0.07);

	@media ${device.MXmd} {
		width: 100%;
		height: 100%;
		right: 50%;
		top: 50%;
		transform: translate(50%, -50%);
	}
`;

export default function Hero({
	isHome,
	title,
	subtitle,
	pretitle,
	heroText,
	heroImage,
	video,
	posterImage,
	loop = false,
	projectLogo,
}) {
	return (
		<>
			<HeroSection className="hero page-width grid--l-1 grid--2">
				<div className="titleWrap text--left">
					{!isHome && <GoBack />}
					{pretitle && <PreTitle>{pretitle}</PreTitle>}
					{title && <Title>{title}</Title>}
					{subtitle && <SubTitle>{subtitle}</SubTitle>}
					{heroText && <HeroText>{heroText}</HeroText>}
				</div>
				<HeroImageWrap>
					<div className="spacer">
						{video && (
							<HeroVideo
								muted
								autoPlay
								playsInline
								loop
								className={'prawn-vid playing'}
								poster={posterImage}
							>
								<source src={video} type="video/mp4" />
							</HeroVideo>
						)}
						{heroImage && (
							<HeroImage heroImage={heroImage}>
								<img
									className="hero-bg-image"
									src={heroImage}
									alt={`${title} Logo`}
									title={`${title} Logo`}
								/>
								{projectLogo && (
									<LogoWrapHero>
										<img
											src={projectLogo}
											alt={`${title} Logo`}
											title={`${title} Logo`}
										/>
									</LogoWrapHero>
								)}
							</HeroImage>
						)}
					</div>
				</HeroImageWrap>
			</HeroSection>
		</>
	);
}
